import type { OverviewExportRecord } from "../Apis/overviewExportTypes";

/**
 * CAR-2738 — notification / toast deep-link may target an export that is
 * older than the first history page (limit 20). Prepend the focused row so
 * it is visible and highlightable without paging the whole history.
 */
export function mergeHighlightedExportIntoHistory(
  history: OverviewExportRecord[],
  focused: OverviewExportRecord | null | undefined,
  highlightExportId?: string
): OverviewExportRecord[] {
  const focusedId = highlightExportId?.trim();
  if (!focusedId) return history;
  if (history.some((item) => item._id === focusedId)) return history;
  if (!focused || focused._id !== focusedId) return history;
  return [focused, ...history];
}
